import React from 'react'
import styled from 'styled-components'

const PointFortsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #fff;
  width: 184px;

  h1 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    margin: 0;
  }

  p {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    margin: 0;
    padding: 0;
  }
`

export const PointForts = ({ icon, title, text }) => (
  <PointFortsContainer>
    <img src={icon} height={122} alt="" />
    <h1>{title}</h1>
    <p>{text}</p>
  </PointFortsContainer>
)
